module.exports = __webpack_public_path__ + "img/broadcast-school-icon4.c1c5cfb1.png";